// Moved verbatim from `src/features/inbox/adapters.ts` (ARCFE-1079).
//
// THE EXCLUSION THAT HELD IT BACK IS SPENT. `agents/inbox` excluded this file
// at ARCFE-1051 because `PendingToolApproval` was a `src/features/tool-approvals`
// contract outside the package, and carving the mapper would have dragged a 4.6
// contract into a 4.2 family ahead of its milestone. ARCFE-1059 moved that
// contract into `contracts/tool-approval.types.ts`, so both sides of the map now
// live in this package's own inert door and the mapper reaches nothing else.
// The exclusion said "it moves when 4.6 does"; 4.6 has moved.
import type { InboxItem } from '../../contracts/inbox.types';
import type { PendingToolApproval } from '../../contracts/tool-approval.types';

/**
 * Maps an InboxItem from the inbox REST API to the FE-local
 * PendingToolApproval shape so existing renderers (ToolApprovalDialog,
 * ComputerUseTaskBlock, InlineClarificationBlock) continue working
 * without changes.
 */
export const inboxItemToPendingApproval = (item: InboxItem): PendingToolApproval => ({
  approvalId: item.approval_id,
  agentRunId: item.render.domain.agent_run_id,
  turnId: null,
  // The inbox API uses approval_id as the tool-call correlation key.
  // If the API later exposes a dedicated tool_call_id, prefer it here.
  toolCallId: item.approval_id,
  toolName: item.render.tool_label ?? 'unknown',
  toolInput: item.tool_input_projection ?? {},
  redactedToolInputKeys: item.redacted_keys,
  createdAt: item.created_at,
  timeoutSeconds: item.expires_at
    ? Math.max(0, Math.floor((new Date(item.expires_at).getTime() - Date.now()) / 1000))
    : null,
  approvalKind: item.approval_kind ?? 'default',
  context: {},
});
